import styled from 'styled-components';

import heroBg from '../../../assets/images/pattern-white.jpg';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Hero = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  background-color: #e74391;
`;

export const HeroImageContainer = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${heroBg});
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: top;
  mix-blend-mode: multiply;

  @media (width < 4000px) {
    background-size: 2260px auto;
  }

  @media (width >= 4000px) {
    background-size: 100% auto;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  min-height: 264px;

  @media (width < 1024px) {
    flex-direction: column;
    justify-content: center;
    padding: 54px 24px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    gap: 34px;
  }
`;

export const HeroClubLogoContainer = styled.div`
  width: 210px;
  height: 45px;

  @media (width < 1024px) {
    margin-bottom: 30px;
  }

  svg {
    width: 100%;

    path {
      fill: #fff;
    }
  }
`;

export const StrategiesLogo = styled.img`
  width: 351px;
`;

export const DescSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 8px;
  max-width: 820px;
  text-align: center;

  @media (width < 1024px) {
    padding: 72px 24px;
  }

  @media (width >= 1024px) {
    padding: 54px 32px;
  }
`;

export const DescTitle = styled.h1`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
  text-transform: uppercase;
`;

export const DescSubtitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  line-height: 25px;
`;

export const Paragraph = styled.span`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const CardsGrid = styled.div`
  display: flex;
  max-width: 1320px;

  @media (width < 1024px) {
    flex-direction: column;
    gap: 24px;
    padding: 16px 0 60px;
  }

  @media (width >= 1024px) {
    justify-content: space-between;
    align-items: flex-start;
    align-self: center;
    gap: 16px;
    padding: 70px 32px 96px;
  }
`;
